<template>
    <div class="container mt-5">
        <div class="row justify-content-center">
            <!-- Inicio de Sección Principal -->
            <div class="col-sm-6 mb-3">
                <div class="element-box">
                    <h5 class="form-header text-center">Solicitud de Reclamo Cliente</h5>
                    <br><br>
                    <div class="row align-items-center">
                        <div class="col-md-12">
                            <TiendaSelectComponent :current="current" />
                            <small style="color: green;">* Tienda donde se hace el reclamo</small>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-md-6 form-group">
                            <label>Solicitante</label>
                            <input type="text" class="form-control" placeholder="Nombre de Cliente"
                                v-model="nombreCliente">
                        </div>
                        <div class="col-md-6 form-group">
                            <label>Teléfono</label>
                            <input type="text" class="form-control" placeholder="5555 5555" v-model="Telefono">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 form-group">
                            <label>Dirección / Domicilio</label>
                            <input type="text" class="form-control" placeholder="Ciudad" v-model="Direccion">
                        </div>
                        <div class="col-md-6 form-group">
                            <label>Motivo de Reclamo</label>
                            <input type="text" class="form-control" placeholder="e.g. Cobro Duplicado" v-model="Motivo">
                            <small style="color: green;">* Breve descripción</small>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Descripción del Caso</label>
                        <textarea class="form-control" rows="5" v-model="Descripcion"></textarea>
                    </div>
                    <div class="row">
                        <div class="col-md-10 form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="sin_transaccion" name="reclamo"
                                    value="sin_transaccion" v-model="selectedOption">
                                <label class="form-check-label" for="sin_transaccion">
                                    Sin Transacción Asociada.
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="transaccion_ligada" name="reclamo"
                                    value="transaccion_ligada" v-model="selectedOption">
                                <label class="form-check-label" for="transaccion_ligada">
                                    Ligar una Transacción (Compra / Cargo)
                                </label>
                            </div>
                        </div>
                        <div class="col-md-2 form-group">
                            <button id="boton1" class="btn btn-md btn-outline-dark"
                                v-if="selectedOption === 'sin_transaccion'" @click="imprimir()">
                                Imprimir &nbsp;<i class="fas fa-print"></i>
                            </button>
                        </div>
                        <p></p>
                        <br>
                        <div class="col-12">
                            <small style="color: lightslategray;">Elaborado por: {{ local_storage.name
                                }}</small>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Fin de Sección Principal -->

            <!---Sección de Cargo o Transacción asociada --->
            <transition name="transition-fade">
                <div class="col-sm-5 mb-3" v-if="selectedOption === 'transaccion_ligada'">
                    <div class="element-box">
                        <div class="del_button" style="width: 40px; height: 40px;" @click="selectSinTransaccion">
                            <a><span><i class="fas fa-times"></i></span></a>
                        </div>
                        <h5 class="form-header text-center">Transacción Asociada
                            &nbsp;&nbsp;
                            <button class="btn btn-md btn-outline-success" id="agregar" data-toggle="modal"
                                data-target="#modalCargo" v-if="!FechaCargo">
                                <i class="fas fa-plus"></i>
                            </button>
                            <button class="btn btn-md btn-outline-dark" id="cambiar" v-else>
                                <i class="fas fa-undo"></i>
                            </button>
                        </h5>
                        <div class="row">
                            <div class="col-md-4 form-group">
                                <label>Fecha Cargo</label>
                                <input type="text" class="form-control" placeholder="" v-model="FechaCargo" disabled>
                            </div>
                            <div class="col-md-7 form-group">
                                <label>Cliente</label>
                                <input type="text" class="form-control" placeholder="" v-model="ClienteNombre" disabled>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 form-group">
                                <label>Serie</label>
                                <input type="text" class="form-control" placeholder="" v-model="SerieFactura" disabled>
                            </div>
                            <div class="col-md-6 form-group">
                                <label>Factura No.</label>
                                <input type="text" class="form-control" placeholder="" v-model="NumeroFactura" disabled>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group">
                                <label>Forma de Pago</label>
                                <input type="text" class="form-control" placeholder="" v-model="FormaPago" disabled>
                            </div>
                            <div class="col-md-5 form-group">
                                <label>Monto</label>
                                <input type="text" class="form-control" placeholder="" v-model="Monto" disabled>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 form-group">
                                <label>Tarjeta Banco</label>
                                <input type="text" class="form-control" placeholder="" v-model="TarjetaBanco"
                                    :disabled="!FechaCargo">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 form-group">
                                <label>Últimos 4 dígitos de Tarjeta</label>
                                <input type="text" class="form-control" placeholder="**** **** **** 1234" maxlength="4"
                                    :disabled="!FechaCargo" v-model="NumTarjeta">
                            </div>
                            <div class="col-md-3 form-group">
                                <label>Tipo de Tarjeta</label>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" id="credito" name="tarjeta_tipo"
                                        value="1" v-model="tipo">
                                    <label class="form-check-label" for="credito">
                                        Crédito
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" id="debito" name="tarjeta_tipo"
                                        value="2" v-model="tipo">
                                    <label class="form-check-label" for="debito">
                                        Débito
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" id="extrafinanciamiento"
                                        name="tarjeta_tipo" value="3" v-model="tipo">
                                    <label class="form-check-label" for="extrafinanciamiento">
                                        Extrafinanciamiento
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" id="extrafinanciamiento"
                                        name="tarjeta_tipo" value="0" v-model="tipo">
                                    <label class="form-check-label" for="extrafinanciamiento">
                                        No es Tarjeta
                                    </label>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-11 form-group">
                                <button id="boton2" class="btn btn-md btn-outline-dark"
                                    :disabled="!FechaCargo || selectedOption !== 'transaccion_ligada'"
                                    style="float: right;" @click="imprimir()">
                                    Imprimir &nbsp;<i class="fas fa-print"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <!---Fin de sección de Cargo o Transacción Asociada --->

            <!-- Modal Selección de Cargo-->
            <div class="modal fade" id="modalCargo" tabindex="-1" role="dialog" aria-labelledby="modalCargoLabel"
                aria-hidden="true">
                <div class="modal-dialog custom-modal" role="document" style="max-width: 90%; width: 90%;">
                    <div class="modal-content">
                        <div class="modal-header" style="background-color: #d5e0e0;">   
                            <h5 class="modal-title" id="modalCargoLabel">Buscar Factura de Cliente</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <TableCargoReclamoClienteComponent :data="data" />                        
                        </div>
                        <div class="modal-footer">
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import CargoTableComponent from "@/components/cxc/cargos/CargoTableComponent";
import TableCargoReclamoClienteComponent from "@/components/cxc/reclamo_cliente/TableCargoReclamoClienteComponent.vue";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
    components: {
        TiendaSelectComponent,
        CargoTableComponent,
        PaginationComponent,
        TableCargoReclamoClienteComponent,
    },
    data() {
        return {
            data: {},
            currentPage: 1,
            incluir_en_blanco: true,
            current: {
                tienda: "02",
                numero: "",
            },
            selectedOption: 'sin_transaccion',
            tipo: '0',
            local_storage: { name: '' },
            nombreCliente: '',
            Telefono: '',
            Direccion: '',
            Motivo: '',
            Descripcion: '',
            TarjetaBanco: '',
            NumTarjeta: '',
            FechaCargo: '',
            ClienteNombre: '',
            SerieFactura: '',
            NumeroFactura: '',
            FormaPago: '',
            Monto: '',
        };
    },
    computed: {
        ...mapGetters({
            tiendas: "catalogos/tiendas",
            clientes: "catalogos/clientes"
        }),
    },
    watch: {},
    mounted() {
        let self = this;
        self.refreshData();
        this.local_storage.name = localStorage.getItem('name');
    },
    methods: {
        refreshData() {
            let self = this;
            DynamicService.fetch("cxc", "cargos").then((response) => {
                self.data = response.data;
            });
        },
        onPageChange(page) {
            let self = this;
            this.currentPage = page;
            DynamicService.fetch("cxc", "cargos", {
                page: page
            }).then((response) => {
                self.data = response.data;
            });
        },
        selectSinTransaccion() {
            this.selectedOption = 'sin_transaccion';
        },
        imprimir() {
            const baseApiUrl = process.env.VUE_APP_ROOT_API;
            const regAsociado = this.selectedOption === 'sin_transaccion' ? 0 : 1;
            const queryParams = [
                `report_format=pdf`,
                `report_name=cxc/reclamo_cliente/reclamo_cliente.jrxml`,
                `tienda_id=${this.current.tienda}`,
                `jefe=${encodeURIComponent(this.local_storage.name)}`,
                `nombre_cliente=${encodeURIComponent(this.nombreCliente)}`,
                `telefono=${encodeURIComponent(this.Telefono)}`,
                `direccion=${encodeURIComponent(this.Direccion)}`,
                `motivo=${encodeURIComponent(this.Motivo)}`,
                `descripcion=${encodeURIComponent(this.Descripcion)}`,
                `tarjeta_banco=${encodeURIComponent(this.TarjetaBanco)}`,
                `tarjeta_num=${encodeURIComponent(this.NumTarjeta)}`,
                `tipo_tarjeta=${this.tipo}`,
                `reg_asociado=${regAsociado}`
            ].join('&');

            const url = `${baseApiUrl}/cat/reporte/?${queryParams}`;

            window.open(url);
        },
    },
};
</script>
<style>
.transition-fade-enter-active,
.transition-fade-leave-active {
    transition: opacity 0.5s ease;
}

.transition-fade-enter,
.transition-fade-leave-to {
    opacity: 0;
}

.modal-dialog.custom-modal {
    max-width: 90%; 
    width: 90%; 
}
</style>